import { c as _c } from "react/compiler-runtime";
import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";
const buttonVariants = cva("inline-flex items-center justify-center rounded-md font-medium transition-all active:scale-[0.98] disabled:opacity-60 disabled:cursor-not-allowed", {
  variants: {
    variant: {
      primary: "bg-blue-600 text-FFFFFF hover:bg-blue-700",
      secondary: "bg-gray-200 text-808080-900 hover:bg-gray-300",
      outline: "border border-808080-400 text-808080-900 hover:bg-gray-100",
      ghost: "text-808080-900 hover:bg-gray-100",
      link: "text-blue-600 underline-offset-4 hover:underline bg-transparent shadow-none px-0",
      icon: "bg-gray-200 hover:bg-gray-300 text-808080-900 p-2 rounded-md",
      iconCircle: "bg-gray-200 hover:bg-gray-300 text-808080-900 p-3 rounded-full",
      destructive: "bg-red-600 text-FFFFFF hover:bg-red-700",
      darkblue: "bg-2D497E text-FFFFFF",
      yellow: "bg-FFDB59 text-FFFFFF"
    },
    size: {
      sm: "h-8 px-3 text-sm",
      md: "h-10 px-4 text-base",
      lg: "h-12 px-6 text-lg",
      icon: "h-10 w-10"
    }
  },
  defaultVariants: {
    variant: "primary",
    size: "md"
  }
});
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {}
export function Button(t0) {
  const $ = _c(12);
  let className;
  let props;
  let size;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      variant,
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = size;
    $[4] = variant;
  } else {
    className = $[1];
    props = $[2];
    size = $[3];
    variant = $[4];
  }
  let t1;
  if ($[5] !== className || $[6] !== size || $[7] !== variant) {
    t1 = cn(buttonVariants({
      variant,
      size,
      className
    }));
    $[5] = className;
    $[6] = size;
    $[7] = variant;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== props || $[10] !== t1) {
    t2 = <button className={t1} {...props} />;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}